import React from "react";

export const Container = ({ children, className: _class, id }) => {
  const className = `page__container ${_class} px-4 md:px-8`;

  return (
    <div className={className} id={id}>
      {children}
    </div>
  );
};
